<template>
  <div class="CBorrow">
    <div class="search" v-if="project_type == '1'">
      <div class="tit_name"><span v-if="checkInfo!=''">搜索结果</span></div>
      <!-- <el-input placeholder="搜索工具/物料" v-model="keyword" class="input-with-select" @keyup.enter.native="screenList">
        <el-button slot="append" icon="el-icon-search" @click="screenList"></el-button>
      </el-input> -->
    </div>
    <div class="cont" v-if="project_type == '1'">
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in pageCount" :key="index" >
          <div class="list">
            <el-row>
              <el-col :span="8" v-for="(box,index2) in boxList[index]" :key="index2">
                <div class="item">
                  <div class="img" v-if="box.image"><img :src="box.image" alt=""></div>
                  <div class="img img2" v-else><img src="../../../../../../static/images/noImg.png" alt=""></div>
                  <div class="itemCont">
                    <div class="num">#{{box.id}}</div>
                    <div class="num" :ref="'name2'+index+''+index2">
                      <div v-if="box.isScrll == false" :ref="'name1'+index+''+index2" class="name1">{{box.name}}</div>
                      <marquee behavior="scroll" v-else>{{box.name}}</marquee>
                    </div>
                    <div class="name num2">数量：{{box.num}}个</div>
                    <el-button @click="toBorrow(index,index2)">借用</el-button>
                    <!-- <el-button @click="toBorrow(index,index2)" v-if="project_type == '2'">打开</el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="cont mt100" v-else>
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in pageCount" :key="index" >
          <div class="list list2">
            <el-row>
              <el-col :span="8" v-for="(box,index2) in boxList[index]" :key="index2">
                <div class="item">
                  <div class="itemCont">
                    <div class="num">#{{box.id}}</div>
                    <div class="flex">
                      <div class="label">品类：</div>
                      <div class="num" :ref="'name2'+index+''+index2">
                        <div v-if="box.isScrll == false" :ref="'name1'+index+''+index2" class="name1">{{box.category}}</div>
                        <marquee behavior="scroll" v-else>{{box.category}}</marquee>
                      </div>
                    </div>
                    <!-- <div class="name num2">数量：{{box.num}}个</div> -->
                    <el-button @click="openDetail(index,index2)">详情</el-button>
                    <el-button @click="toBorrow(index,index2)">打开</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="backUp">
      <el-button @click="refresh" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="全局盘点中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">刷新</el-button>
      <template v-if="project_type == '1'">
        <el-button @click="toSearch" v-if="checkInfo==''">全局搜索</el-button>
        <el-button @click="clearAll" v-else>清空搜索</el-button>
      </template>
      <el-button @click="loginOut">退出登录</el-button>
    </div>
    <!-- <el-button class="backUp" @click="loginOut">退出登录</el-button> -->
    <template v-if="project_type == '1'">
    <div class="adminBtn" v-if="isAdmin == 0"><el-button type="info" @click="toAdmin">管理员入口</el-button></div>
    </template>
    
    <el-dialog :title="dioTitle" :visible.sync="detDio" width="70%" class="detDio">
      <div class="totalDetail">总数：{{totalDetail}}</div>
      <div class="contDio" v-if="dioData != ''">
        <div class="item" v-for="(item,index) in dioData" :key="index">
          <div class="cont">
            <div class="spec">
              <span>规格:{{item.spec}}</span>
              <!--暂时显示-->
              <span>RFID:{{item.rfid}}</span>
              <span>{{item.supplier}}</span>
            </div>
            <div class="name">{{item.product_name}}</div>
            <div class="tips">
              <p>
                <span>批号:{{item.lotno}}</span>
                <span>效期:{{item.validdate}}</span>
                <span>注册证:{{item.regno}}</span>
                <span>生产日期:{{item.proddate}}</span>
              </p>
            </div>
          </div>
          <div class="num">{{item.number}}</div>
        </div>
        <!-- <el-table :data="dioData" height="6rem" style="width:100%" cell-class-name="ellipsis">
          <el-table-column prop="product_name" label="产品名称"></el-table-column>
          <el-table-column prop="spec" label="规格"></el-table-column>
          <el-table-column prop="supplier" label="供应商"></el-table-column>
          <el-table-column prop="number" label="库存" width="150"></el-table-column>
        </el-table> -->
      </div>
      <div class="noData" v-else>暂无数据</div>
    </el-dialog>

    <el-dialog title="非法标签" :visible.sync="errofDio" width="60%" class="errDio">
      <div class="contDio">
        <div class="errTit">检测到非法标签<span>{{errNum}}</span>个</div>
        <div class="list" v-for="(item,index) in errorRfid" :key="index">
          <div class="label">{{item.locationid}}号：</div>
          <div class="listItem">{{item.rfid.join('、')}}</div>
        </div>
      </div>
    </el-dialog>
    
    <!-- <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" ref="mqttws"  @getMessage="getMessage"></mqttws> -->
    <currtime :isShowInfo="true"></currtime>
  </div>
</template>

<script>
import currtime from '../../../../../assets/currTime'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import mqttws from '../../../../../assets/mqttws'
import { checkData,strToHexCharCode } from '../../../../../../static/js/utils/util.js'
import { showLoading,hideLoading,localUserInfo,conLog } from '../../../../../../static/js/utils/utility.js'
import { borrowApi, wareApi } from "../../../../../../static/js/api.js"
import * as config from '../../../../../../static/js/config.js';
import qs from 'qs'

import { websocketsend } from  '../../../../../../static/js/utils/socket.js'

var vm
export default {
  name: 'CBorrow',
  data () {
    
    return {

      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response',
      msg:'',
      isConnect:true,//是否默认订阅

      project_type:'',
      activeIndex: 0,
      isAdmin:'',//是否是管理员
      user_id:'',//用户id
      keyword:'',//搜索关键词
      boxList:[],//箱格列表
      allList:[],//所有列表

      pageCount:0,//总页数
      limits:6,//每页显示数

      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets:true,
        },
        on: {
          slideChangeTransitionStart(){
            vm.activeIndex = vm.$refs.mySwiper.swiper.activeIndex
            var index = vm.$refs.mySwiper.swiper.activeIndex
            
            for(var ii in vm.boxList[index]){
              var ref1 = 'name1'+index+ii
              var ref2 = 'name2'+index+ii
              if(vm.$refs[ref1].length!=0){
                if(vm.$refs[ref1][0].offsetWidth > vm.$refs[ref2][0].offsetWidth){
                  vm.boxList[index][ii].isScrll = true
                }
              }
            }
            
          },
        },
        observer:true, 
        observeParents:true
      },

      detDio:false,
      dioTitle:'',
      dioData:[],

      checkInfo:[],//搜索选中产品编号列表

      total:0,//箱格总数
      fullscreenLoading:false,//全屏loading

      time2:60,
      timeStatus2:'',

      errorRfid:[],//非法rfid
      errNum:0,
      errofDio:false,

      overtime:60,//超时
      overtimeStatus:'',//超时状态

      totalDetail:0,//详情总数
    }
  },
  //定义这个sweiper对象  
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;  
    }  
  },
  mounted(){
    
  },
  created() {
    vm = this
    var configStorage = JSON.parse(localStorage.getItem('configStorage'))
    if(configStorage){
      this.project_type = configStorage.unmanShow
      if(this.project_type=='1'){
        vm.limits=6
      }else{
        vm.limits=3
      }
    }
    this.isAdmin = localUserInfo.getItem().is_admin
    this.user_id = localUserInfo.getItem().user_id
    var checkInfo = JSON.parse(sessionStorage.getItem('checkInfo'))
    if(checkInfo){
      this.checkInfo = checkInfo
    }
    this.getBoxList()
    this.overTime(this.overtime)
  },
  components:{
    mqttws,
    swiper,
    swiperSlide,
    currtime
  },
  methods:{
    //接收socket
    getSkMsg(res){
      var that = this;
      if(res){
        if(res.meta){
          if(res.meta.fun_code == 'd707'){
            that.time2 = 60;
            that.overtime = 60
            if(res.meta.code == 200){
              that.total = this.total - 1
              clearTimeout(that.timeStatus2)
              if(that.total <= 0){
                that.getBoxList()
                that.fullscreenLoading = false
              }
            }
          }
        }
      }
    },
    //超时
    overTime(wait){
      conLog('CBorrowOvertime',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.overtimeStatus)
        that.loginOut()
      } else {
        that.overtime=wait
        that.overtime--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(that.overtime);
        },1000);
      }
    },
    //倒计时
    getSecond2(wait){
      conLog('CBorrowgetSecond2',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.timeStatus2)
        that.fullscreenLoading = false;
        that.time2 = 60
      } else {
        this.time2=wait
        wait--;
        that.timeStatus2 = setTimeout(function() {
          that.getSecond2(wait);
        },1000);
      }
    },
    //接收mqtt信息
    getMessage(data){
      var that = this;
      if(data && that.fullscreenLoading == true){
        var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
        var str2 = data.substring(2,data.length);
        var num = checkData(str)
        var bbc = data.substr(data.length-2)
        var type = str.substring(26,30)
        // console.log('type',type)
        if( type == 'd608'){
          that.time2 = 60;
          that.overtime = 60
          var lastTwo = str.substring(str.length-2,str.length)
          // console.log('lastTwo',lastTwo)
          if(num == bbc && lastTwo == '01'){
            var topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
            that.$refs.mqttws.onConnect(topic)
          }else{
            var topic1 = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d608000100'
            var num2 = checkData(msg)
            msg = msg+num2
            that.$refs.mqttws.send(topic1,msg)
          }
        }if( type == 'd707'){
          that.time2 = 60;
          that.overtime = 60
          var lastTwo = str.substring(str.length-2,str.length)
          if(num == bbc && lastTwo == '01'){
            var topic2 = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
            that.$refs.mqttws.onConnect(topic2)
          }else{
            var topic3 = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d707000100'
            var num2 = checkData(msg)
            msg = msg+num2
            that.$refs.mqttws.send(topic3,msg)
          }
        }else if(type == 'df10'){
          that.time2 = 60;
          that.overtime = 60
          if(num == bbc){
            var number = parseInt(str.substring(34,36));
            that.total = this.total - number
            var topic4 = '/'+ config.clientPort +'/report/'+ config.serverPort +'/readallbox/toolcabinet'
            clearTimeout(that.timeStatus2)
            that.time2 = 60
            that.overtime = 60
            that.allInventory(str2,topic4)
          }
          
        }else if(type == 'd708'){
          that.time2 = 60;
          that.overtime = 60
          if(num == bbc){
            var number = parseInt(str.substring(34,36));
            that.total = this.total - 1
            var topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/readallbox/medicalwarehouse'
            clearTimeout(that.timeStatus2)
            that.time2 = 60
            that.overtime = 60
            that.allInventory(str2,topic)
          }
          
        }
      }
    },
    
    //发送盘点数据
    async allInventory(data,topic){
      var that = this;
      var dataObj = {
        'topic':topic,
        'data':data,
        'user_id': that.user_id,
        'user': localUserInfo.getItem().user_name,
      }
      var res = await borrowApi.allInventory(dataObj)
      if(res.meta.code == 200){
        if(that.total <= 0){
          that.getBoxList()
          that.fullscreenLoading = false
        }
        if(res.body.error){
          that.errofDio = true
          that.errNum += res.body.error.rfid.length
          that.errorRfid.push(res.body.error);
        }
      }else{
        that.fullscreenLoading = false
        that.$message.error(res.meta.message)
      }
    },
    //刷新
    refresh(){
      var that = this;
      this.errNum=0
      this.errorRfid = []
      this.fullscreenLoading = true
      this.getSecond2(this.time2)
      if(this.project_type == '1'){
        //发送全局盘点
        for(var i in that.allList){
          var time = Date.parse(new Date())/1000;//精确到秒时间戳
          websocketsend('d707'+that.allList[i].id+','+that.user_id+',1,'+time+',')
        }
        // var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
        // var msg = 'a5551505160101010000000101d608000100'
        // var num = checkData(msg)
        // msg = msg+num
        // // console.log(topic,msg)
        // that.$refs.mqttws.send(topic,msg)
      }else{
        //发送全局盘点
        for(var i in that.allList){
          var time = Date.parse(new Date())/1000;//精确到秒时间戳
          websocketsend('d707'+that.allList[i].id+','+that.user_id+',1,'+time+',')
        }
        // var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
        // var msg = 'a5551505160101010000000101d707000100'
        // var num = checkData(msg)
        // msg = msg+num
        // // console.log(topic,msg)
        // that.$refs.mqttws.send(topic,msg)
      }
    },
    //清空搜索
    clearAll(){
      this.overtime = 60
      this.checkInfo = []
      sessionStorage.removeItem('checkInfo')
      this.screenList()
    },
    //全局搜索
    toSearch(){
      clearTimeout(this.overtimeStatus)
      // this.$refs.mqttws.disconnect()
      this.$router.push({
        path:'/toolCabinet/CSearchList',
      })
    },
    //打开详情
    openDetail(index,index2){
      this.overtime = 60
      this.detDio=true;
      this.dioTitle = '#'+this.boxList[index][index2].id
      this.dioData = this.boxList[index][index2].list;//暂时使用线上接口获取详情
      var totalDetail = 0
      for(var i in this.dioData){
        totalDetail += parseInt(this.dioData[i].number)
      }
      this.totalDetail = totalDetail
      // this.getDetail(this.boxList[index][index2].id)
    },
    //在线获取产品详情
    // async getDetail(id){
    //   var that = this
    //   var data = {
    //     'device_no_id':config.deviceId,
    //   }
    //   var res = await borrowApi.boxLists(data)
    //   if(res.meta.code == 200){
    //     for(var i in res.body){
    //       if(id == res.body[i].id){
    //         that.dioData = res.body[i].list
    //       }
    //     }
    //   }
    // },
    //获取箱格列表
    async getBoxList(){
      var that = this
      // showLoading();
      // var data = {
      //   'device_no_id':config.deviceId,
      // }
      // var res = await borrowApi.boxLists(data)
      var data = {
        'api':'box',
      }
      var res = await wareApi.ylcbdh(qs.stringify(data))
      if (res.meta.code == 200) {
        for(var i in res.body){
          res.body[i].name = ''
          res.body[i].category=''
          res.body[i].num = 0

          //把小于等于9的id都在前面添加‘0’,再转成字符串
          if(res.body[i].id <= 9){
            res.body[i].id = '0'+res.body[i].id
          }
          res.body[i].id = res.body[i].id.toString()

          res.body[i].isScrll = false
          if(res.body[i].list != ''){
            for(var ii in res.body[i].list){
              var name = res.body[i].name+'、'+res.body[i].list[ii].product_name
              res.body[i].name = name
              var category = res.body[i].category+','+res.body[i].list[ii].category
              res.body[i].category=category
              //获取分类名组成一个字符串，且不能有重复的名称，再把是‘null’的去掉
              var str = res.body[i].category;
              var ret = [];
              str.replace(/[^,]+/g, function($1, $2){
                (str.indexOf($1) == $2) && ret.push($1);
              });
              res.body[i].category = ret.join(',')
              res.body[i].category = res.body[i].category.replace('null','')
              res.body[i].num += res.body[i].list[ii].number
            }
            res.body[i].name = res.body[i].name.slice(1)
          }else{
            res.body[i].name = '暂无物品'
            res.body[i].category = '暂无品类'
          }
          if(res.body[i].category == ''){
            res.body[i].category = '暂无品类'
          }
        }
        that.allList = res.body
        that.total = res.body.length
        that.screenList()
        // hideLoading();
      } else {
        // hideLoading();
        that.$message.error(res.meta.message)
        // showToast(res.meta.message)
      }
    },
    //列表筛选
    screenList(){
      var that = this;
      var allList = that.allList
      var limits = that.limits;//每页显示条数
      var searchList = []
      this.overtime = 60
      // console.log('checkInfo',that.checkInfo)
      // console.log('allList',that.allList)
      if(that.project_type == '1'){
        if(that.checkInfo!=''){
          for(var i in allList){
            for(var x in allList[i].list){
              for(var ii in that.checkInfo){
                if(allList[i].list[x].sn==that.checkInfo[ii].sn){
                  searchList.push(allList[i])
                }
              }
            }
          }
          
          //去重处理
          var result = [],arr = [];
          var obj = {};
          arr = searchList
          for(var i =0; i < arr.length; i++){
            if(!obj[arr[i].id]){
              result.push(arr[i]);
              obj[arr[i].id] = true;
            }
          }
          searchList = result
          // console.log('searchList',searchList)
          for(var i in that.checkInfo){
            for(var x in searchList){
              for(var y in searchList[x].list){
                if(that.checkInfo[i].sn == searchList[x].list[y].sn){
                  searchList[x].name = searchList[x].list[y].product_name
                }
              }
            }
          }

        }else{
          // console.log(allList)
          for(var i in allList){
            allList[i].name=''
            if(allList[i].list != ''){
              for(var ii in allList[i].list){
                var name = allList[i].name+'、'+allList[i].list[ii].product_name
                allList[i].name = name
              }
              allList[i].name = allList[i].name.slice(1)
            }else{
              allList[i].name = '暂无物品'
            }
          }
          searchList = allList
        }
        
      }else{
        for(var i in allList){
          if(that.keyword!=''){
            if(allList[i].name.indexOf(that.keyword) != -1){
              searchList.push(allList[i])
            }
          }else{
            searchList = allList
          }
        }
      }
      //计算到分页的总页数（向上取整）
      that.pageCount = Math.ceil(searchList.length/limits)
      var arr = []
      for(var i = 0, j = searchList.length; i < j; i += limits){
        arr.push(searchList.slice(i,i+limits))
      }
      that.boxList =arr

      //判断是否需要文字横向滚动
      that.$nextTick(function(){
        for(var ii in arr[0]){
          var ref1 = 'name1'+'0'+ii
          var ref2 = 'name2'+'0'+ii
          if(vm.$refs[ref1].length!=0){
            if(that.$refs[ref1][0].offsetWidth > that.$refs[ref2][0].offsetWidth){
              arr[0][ii].isScrll = true
            }
          }
        }
        that.boxList =arr
      })
    },
    
    //退出登录
    loginOut(){
      var that=this
      // this.$refs.mqttws.disconnect()
      clearTimeout(that.overtimeStatus)
      localUserInfo.removeItem()
      if(this.project_type == '1'){
        that.$router.push({
          path:'/toolCabinet/CLogin'
        })
      }else if(this.project_type == '2'){
        that.$router.push({
          path:'/unmanned/wrcIndex',
        })
      }
      
    },
    //借用
    toBorrow(index,index2){
      var that = this
      var id = this.boxList[index][index2].id
      var name = this.boxList[index][index2].name
      this.overtime = 60
      // if(name == '暂无物品'){
      //   that.$message.error('该箱格没有物品！')
      // }else{
        clearTimeout(that.overtimeStatus)
        // that.$refs.mqttws.disconnect()
        that.$router.push({
          path:'/toolCabinet/CBorrow/COpenDoor',
          query:{
            boxId: id
          }
        })
      // }
    },
    //跳转到管理员页面
    toAdmin(){
      var that = this;
      var isAdmin = localUserInfo.getItem().is_admin
      this.overtime = 60
      if(isAdmin == '0'){
        clearTimeout(this.overtimeStatus)
        // that.$refs.mqttws.disconnect()
        that.$router.push({
          path: '/toolCabinet/CAdmin',
        })
      }else{
        that.$message.warning('你没管理员权限！')
      }
    }
  },
  watch :{
    "$store.state.wsMsg":function(newVal){
      console.log('msg2',newVal)
      this.getSkMsg(newVal)
    }
  },
}
</script>

<style lang="less">
.CBorrow{
  padding: 0.55rem 0 0.35rem;
  touch-action: none;
  height: 100vh;
  box-sizing: border-box;
  .totalDetail{ 
    font-size: 0.3rem;
    color: #666;
    margin-bottom: 0.2rem;
  }
  .errDio{
    .el-dialog__body{
      padding: 0 0.2rem 0.3rem;
    }
    .errTit{
      font-size: 0.36rem;
      color: #333;
      span{
        color: #F56C6C;
      }
    }
    .list{
      font-size: 0.3rem;
      color: #666;
      max-height: 5rem;
      overflow: auto;
      margin:0.2rem;
      box-sizing: border-box;
      display: flex;
      .label{
        width: 1.2rem;
        flex-shrink: 0;
      }
      .listItem{
        flex-grow: 1;
      }
    }
  }
  .detDio{
    .noData{
      height: 6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.3rem;
      color: #999;
    }
    .contDio{
      height: 6rem;
      overflow: auto;
      .item{
        border: 0.02rem solid #ddd;
        margin-bottom: 0.2rem;
        position: relative;
        font-size: 0.23rem;
        color: #666;
        display: flex;
        justify-content:space-between;
        align-items: center;
        border-radius: 0.1rem;
        padding: 0.12rem 0.2rem;
        line-height: 0.4rem;
        span{ margin-right: 0.2rem;}
        .num{
          padding: 0.2rem;
          border-radius: 0.1rem;
          border: 0.01rem solid #ddd;
          font-size: 0.36rem;
          color: #0769be;
          flex-shrink: 0
        }
        .cont{
          margin-right: 0.2rem;
          flex-grow: 1;
          .name{
            font-size: 0.3rem;
            color: #333;
          }
          .tips{
            color: #47a7fb;
          }
        }
      }
    }
    .el-dialog{ background: #fff;}
    .el-dialog__header{
      padding: 0.2rem;
      background-color:#fff;
      .el-dialog__title{
        font-size: 0.6rem;
      }
      >.el-dialog__headerbtn {
        top: 0.15rem;
      }
    }
    .el-dialog__body{
      padding: 0 0.3rem 0.2rem;
    }
    .ellipsis>div{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-table{
      font-size: 0.3rem;
      tr:hover>td{
        background: none;
      }
    }
    .el-table td, .el-table th{
      padding: 0.2rem 0;
      font-size: 0.3rem;
      border-bottom: 0.02rem solid #ebeef5;
    }
    .el-table .cell{
      line-height: 0.32rem;
    }
  }
  .mt100{
    margin-top: 1rem;
  }
  .swiper-container {
    height: 7.08rem;
    .list{
      height: 7.08rem;
      // margin: 0 2.16rem;
      margin: 0;
      // background: linear-gradient(#3f84b2, #42596e);
      padding: 0.74rem 1.18rem;
      // box-shadow: 0 0.08rem 0.07rem 0.03rem rgba(68, 76, 128, 0.26);
      .el-col-8{
        padding-left: 0.26rem;
        padding-right: 0.26rem;
      }
      
      .item{
        background: #f0f0f0;
        border-radius: 0.1rem;
        margin-bottom: 0.27rem;
        padding: 0.28rem 0.28rem 0.28rem 1.8rem;
        font-size: 0.42rem;
        width: 5.18rem;
        height: 2.49rem;
        box-sizing: border-box;
        position: relative;
        .van-notice-bar{
          height: 0.4rem;
          padding: 0 0.15rem;
          background: none;
          font-size: 0.32rem;
          line-height:inherit;
          color: #333;
        }
        .van-notice-bar__wrap{
          height: 0.4rem;
        }
        .img{
          width: 1.35rem;
          height: 1.93rem;
          background: #2d83f3;
          position: absolute;
          left: 0.28rem;
          top: 50%;
          margin-top: -0.965rem;
          img{width: 100%;}
          &.img2{
            display: flex;
            align-items: center;
            justify-content: center;
            img{ width: 80%;}
          }
        }
        .itemCont{
          .name{
            font-size: 0.32rem;
            color: #666;
          }
          .name1{
            white-space: nowrap;
            display: inline;
          }
          .num{
            line-height: 1;
            color: #333;
          }
          .num2{
            font-size: 0.26rem;
            color: #999;
          }
        }
        .el-button{
          // margin-top: 0.2rem;
          height: auto;
          padding: 0.16rem 0.6rem;
          font-size: 0.34rem;
          font-weight: bold;
          color: #fff;
          border: none;
          border-radius: 0.1rem;
          line-height:inherit;
          background: #47a7fb;
        }
      }
      &.list2{
        height: 6.08rem;
        padding-top:1.24rem;
        .item{
          padding: 0.28rem;
          height: 5rem;
          box-sizing: border-box;
          .flex{
            flex: 1;
            overflow: hidden;
            align-items: center;
            margin: 0.2rem 0 0.8rem;
            .label{
              width:28%;
              flex-shrink: 0;
              color: #333;
            }
            .num{
              width: 72%;
              flex-grow: 1;
            }
          }
          .el-button{
            display: block;
            margin: 0.28rem 0;
            width: 100%;
          }
        }
      }
    }
  }
  .backUp{
    position: absolute;
    right: 0.94rem;
    bottom: 0.47rem;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
      margin-left: 0.2rem;
    }
  }
  .adminBtn{
    position: absolute;
    left: 0.94rem;
    bottom: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .search{
    width: 48.5%;
    margin: 0 auto 0.5rem;
    .tit_name{
      height: 0.85rem;
      line-height: 0.85rem;
      text-align: center;
      font-size: 0.6rem;
    }
    .el-input-group{
      font-size: 0.3rem;
      display: flex;
      align-items: center;
      .el-input__inner{
        display: inline-flex;
        height: 0.85rem;
        line-height: 0.85rem;
        background: #fff;
        color: #666;
        border: none;
        border-radius: 0;
        border-top-left-radius: 0.1rem;
        border-bottom-left-radius: 0.1rem;
        padding: 0 0.3rem;
        box-sizing: border-box;
      }
      .el-input-group__append, .el-input-group__prepend{
        width: auto;
        display: inline-flex;
        background: #fff;
        color: #525252;
        height: 0.85rem;
        border: none;
        border-radius: 0;
        font-size: 0.4rem;
        border-top-right-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
      }
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CEmployee/CBorrow/CBorrow.vue